// extracted by mini-css-extract-plugin
export default {"container":"CurrencyConverter_container__xU9bC","exchange_icon_container":"CurrencyConverter_exchange_icon_container__ZnLxO","exchange_icon":"CurrencyConverter_exchange_icon__9BIzU"};